// KPI Period Action Types

export const FETCH_PERIODS_REQUEST = 'kpiPeriod/FETCH_PERIODS_REQUEST';
export const FETCH_PERIODS_SUCCESS = 'kpiPeriod/FETCH_PERIODS_SUCCESS';
export const FETCH_PERIODS_FAILURE = 'kpiPeriod/FETCH_PERIODS_FAILURE';

export const FETCH_PERIOD_BY_ID_REQUEST = 'kpiPeriod/FETCH_PERIOD_BY_ID_REQUEST';
export const FETCH_PERIOD_BY_ID_SUCCESS = 'kpiPeriod/FETCH_PERIOD_BY_ID_SUCCESS';
export const FETCH_PERIOD_BY_ID_FAILURE = 'kpiPeriod/FETCH_PERIOD_BY_ID_FAILURE';

export const CREATE_PERIOD_REQUEST = 'kpiPeriod/CREATE_PERIOD_REQUEST';
export const CREATE_PERIOD_SUCCESS = 'kpiPeriod/CREATE_PERIOD_SUCCESS';
export const CREATE_PERIOD_FAILURE = 'kpiPeriod/CREATE_PERIOD_FAILURE';

export const UPDATE_PERIOD_REQUEST = 'kpiPeriod/UPDATE_PERIOD_REQUEST';
export const UPDATE_PERIOD_SUCCESS = 'kpiPeriod/UPDATE_PERIOD_SUCCESS';
export const UPDATE_PERIOD_FAILURE = 'kpiPeriod/UPDATE_PERIOD_FAILURE';

export const DELETE_PERIOD_REQUEST = 'kpiPeriod/DELETE_PERIOD_REQUEST';
export const DELETE_PERIOD_SUCCESS = 'kpiPeriod/DELETE_PERIOD_SUCCESS';
export const DELETE_PERIOD_FAILURE = 'kpiPeriod/DELETE_PERIOD_FAILURE';

export const SET_PERIOD_FILTERS = 'kpiPeriod/SET_PERIOD_FILTERS';
export const SET_PERIOD_PAGINATION = 'kpiPeriod/SET_PERIOD_PAGINATION';
export const RESET_PERIOD_STATE = 'kpiPeriod/RESET_PERIOD_STATE';
